/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import './scripts/globals';
import 'bootstrap-sass';

import flatpickr from './flatpickr';
import 'air-datepicker';
import 'air-datepicker/dist/js/i18n/datepicker.de';
import 'admin-lte';

import './scripts/main';
import './scripts/register';
import './scripts/jquery_mask_min';
import './scripts/bootstrap-slider';
import './scripts/jquery_data-tables';
import './scripts/datepicker_min';
import './scripts/datepicker_de';

// Moment.js
//window.moment = require('moment');

// Air Datepicker
import 'selectize';
import './scripts/extras';
import 'jvectormap-next';
import './jvectormap/jquery-jvectormap-de-merc';

import Swal from 'sweetalert2';

// add flatpicker to jQuery
if (typeof jQuery !== 'undefined' && typeof jQuery.fn !== 'undefined') {
  jQuery.fn.flatpickr = function (config) {
    return flatpickr(this, config);
  };
}

//Sweet Alert 2
window.Swal = Swal;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error(
    'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token'
  );
}

/**
 * Define Root Url of the current project
 */
window.rootUrl =
  document.head.querySelector('meta[name="rootUrl"]').content ?? '';
